module.exports = __webpack_public_path__ + "static/img/clothing_07.68be8a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_07.png
// module id = dYqL
// module chunks = 0